import type { CliError } from './cli-error.js';

export function cliErrorToError(cliError: CliError): Error {
  const cause = cliError.cause();
  const error = cause
    ? new Error(cliError.message, { cause })
    : new Error(cliError.message);

  error.name = cliError.name;
  error.stack = cliError.stack;

  return error;
}
